import { useState, FC } from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { createFormPopupJson } from '../../Utils/common';
import "./style.scss";
import useNavigateParams from '../../CustomHooks/useNavigateParams';
import LazyImage from '../LazyImage';
import CorruptedPage from '../../assets/corrupted-file-image.png'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { getIframeUrl } from '../../Services/API';
import { Backdrop } from '@mui/material';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
        display: 'flex',
        'justify-content': 'center',
        'align-items': 'center',
        'flex-direction': 'column',

    },
    '& .MuiPaper-root': {
        'max-width': 'initial',
        padding: '20px'
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

interface CreateNewFormPopupTypes {
    open: boolean;
    setOpen: (open: boolean) => void;
    setTosterOpen?: (props: {
        open: boolean;
        message: string;
        severity: string;
    }) => void;
    getFormDatas?: () => void;
}

const CreateNewFormPopup: FC<CreateNewFormPopupTypes> = ({ open, setOpen, setTosterOpen, getFormDatas }) => {
    const customNavigate = useNavigateParams();
    const [openCreateWithAi, setOpenCreateWithAi] = useState(false)
    const [loading, setLoading] = useState(false)
    const [iframeId, setIframeId] = useState("")

    const handleOpenAiChatbot = async () => {
        try {
            setLoading(true)
            const IframeUrlResponse = await getIframeUrl()
            if (IframeUrlResponse.code === 200 && IframeUrlResponse?.data?.url) {
                const id = IframeUrlResponse?.data?.url?.split('?id=')
                if (id.length > 1) {
                    setIframeId(id[1])
                }
            }
        } catch (e: any) {
            console.error("ERROR in Handle_Open_AI_Chatbot", e?.message || e)
        } finally {
            setOpenCreateWithAi(true)
            setLoading(false)
        }
    }

    const handleClicks = (type: string) => {
        switch (type) {
            case "Start from scratch":
                customNavigate("/createform", { newForm: 1 });
                break;
            case "Select from template":
                break;
            case "Create with AI":
                handleOpenAiChatbot()
                break;
        }
    }


    return (
        <BootstrapDialog
            aria-labelledby="customized-dialog-title"
            open={open}
        >
            <IconButton
                aria-label="close"
                onClick={() => setOpen(false)}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent>
                <div className='create-form-header'>{openCreateWithAi ? 'Create form using Ai' : `Create a new form`}</div>
                {openCreateWithAi && <KeyboardBackspaceIcon className='back-button' onClick={() => { setOpenCreateWithAi(false) }} />}
                <div className={openCreateWithAi ? 'ai-form-container' : 'card-container'}>
                    {openCreateWithAi ? <div className='ai-form-inner-container'>
                        {!loading &&
                            (iframeId ?
                                <iframe
                                    title='mini-chatbot-iframe'
                                    id="mini-chatbot-iframe"
                                    src={`${process.env.REACT_APP_CHATBOT_URL}?source=manager&domain=waymore.io&manager_type=conversational_form&id=${iframeId}`}
                                    height="550px"
                                    width="1100px"
                                />
                                :
                                <div className='failed-to-load'>
                                    <LazyImage imgSrc={CorruptedPage} />
                                    <span>
                                        Unable to open chatbot at the moment
                                    </span>
                                    <span>
                                        Please try again later
                                    </span>
                                </div>)
                        }
                    </div> :
                        createFormPopupJson?.map((data) => {
                            return <div className={`each-card ${data.Header === "Select from template" ? "coming-soon-card" : ""}`}>
                                {data.Header === "Select from template" && <span className="ribbon">Coming Soon</span>}
                                <button className='each-card-button' type="button" onClick={() => handleClicks(data.Header)}>
                                    <div className='img-container'>
                                        <LazyImage imgSrc={data.icon} />
                                    </div>
                                    <div className='text-container'>
                                        <span className='text-header'>{data.Header}</span>
                                        <div className="Spacer"></div>
                                        <span className='text-description'>{data.description}</span>
                                    </div>
                                </button>
                            </div>
                        })
                    }
                </div>
            </DialogContent>
            <Backdrop
                open={loading}
                className='backdrop-container'
            >
                <div className='loading-container'> <img src={'https://go.waymore.io/assets/icons/campaigns/logo-loader.gif'} className="loader-gif" alt="Loading..." /><div>Please wait...</div></div>
            </Backdrop>
        </BootstrapDialog >
    )
}

export default CreateNewFormPopup